import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import './components/suporteProfissional';
import './components/clienteApiAmbiente';
import FaixaAmbienteDesenvolvimento from './components/FaixaAmbienteDesenvolvimento';
import React from 'react';
import ReactDOM from 'react-dom/client';
//import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
//import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';


//ReactDOM.render(<App />, document.getElementById('root'));
const container = document.getElementById('root');
const root = ReactDOM.createRoot(container); // createRoot(container!) if you use TypeScript
root.render(

    <><FaixaAmbienteDesenvolvimento/><App tab="/" /></>

);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();

reportWebVitals();




